__turbopack_context__.v({
  "nodata": "TransactionTable-module__ujMpGG__nodata",
  "transactionTableScope": "TransactionTable-module__ujMpGG__transactionTableScope",
});
